import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Modal,
  Table,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
//import Select from "react-dropdown-select";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile from "read-excel-file";
//import Util from "../../../Common/util";
import XLSX from "xlsx";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import { MDBDataTable } from "mdbreact";
//import API from "../../../Common/api";
import _ from "lodash";
import "./styles.css";
import LoadingOverlay from "react-loading-overlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import Alert from "reactstrap/lib/Alert";
//import styled, { css } from "styled-components";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';



var url = window.location.hostname;
var port = window.location.port;
var data_img = [];
var assign_arr= [];
var unassign_arr = [];
var data_type = "";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.getCookie = this.getCookie.bind(this);
  
    this.accessCookie = this.accessCookie.bind(this);
    this.toggle = this.toggle.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.SuccessConfirmtoggle = this.SuccessConfirmtoggle.bind(this);
    this.getStoreList = this.getStoreList.bind(this);
    this.getPicksheetId=this.getPicksheetId.bind(this);
    this.UnAssign = this.UnAssign.bind(this);
    this.assignedOrdersList = this.assignedOrdersList.bind(this);
    this.Assign = this.Assign.bind(this);
    this.toggleOK = this.toggleOK.bind(this);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle2OK = this.toggle2OK.bind(this);

    this.getStationList = this.getStationList.bind(this);
    this.getAudit = this.getAudit.bind(this);

    this.getReason = this.getReason.bind(this);

    this.OpenAssign = this.OpenAssign.bind(this);
    this.AssignData = this.AssignData.bind(this);



    this.state = {
      orderdata: [],
      variant_data: [],
      shelf_life_uom: [],
      ShowpopupLoader: false,
      isDisableConfirm: true,
      taskid: "",
      showFilter: false,
      ShowConfirmLoader: false,
      stationType: [],
      unAssignOrder: [],
      assignOrder: [],
      isDisabledSearch: false,
      showConfirmError: false,
      auditData: [],
      reasonData: [],
      group_id: "",
      selectedOutlet: "",
      selectedDistributor: "",
      selectedLocation: "",
      selectedOrder: "",
      submitData: false,
      order: [],
      row_data: [],
      arr_data: [],
      store: [],
      subStore:[],
      schemas: [],
      distributor:[],
      selectedReason: "",
      selectedAudit: "",
      selectedPackedQty: "",
      outlet:[],
      location: [],
      EditModal: false,
      hsn_value: "",
      loader1: false,
      showVariant: false,
      isDisabledApply: false,
      disabledcheck: false,
      mc_code: false,
      hsn_code: [],
      applyPackSize: "",
      selectedPicksheet: "",
      showTable: false,
      status_type: "1",
      apply: true,
      store_id: "",
      sub_store_id:"",
      task_id: "",
      polaris_id: "",
      task_type_value: "",
      selectedStation: "",
      request_id: "",
      showUnAssignedOrder: false,
      showFetchDispatchData: false,
      selectedStation:"",
      disabledBtn: false,
      showData: false,
      showErrorMessage: false,
      product_id: null,
      brand_value: "",
      mc_code_value: "",

      apply1: true,
      total_value: "",
      total_quantity: "",

      shelf_life_data: [],
      modal: false,
      selectedGroup: "",
      selectedSubGroup:"",
      modal1: false,
      modal2: false,
      modalFailed: false,
      showAllItem: false,
      disabledReasonBtn: true,
      showInvalidItem: false,
      showProceedbtn: false,
      showReasonbtn: false,
      reasonCodeNeeded: false,
      SuccessConfirmmodal: false,
      modalReason: false,
      loadingconfirmbtn: false,
      loading: false,
      loading_overlay: false,
      url: window.location.hostname,
      port: window.location.port,
      isChecked: false,
    };
  }

  Assign(){
      this.fetchDispatch();
  }

  UnAssign(){
      this.setState({
       
        loading_overlay: true,

      })
      const payload = {
        location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
         showUnAssignedOrder: false,
        showAssignedOrder: true,
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders,
        loading_overlay: false,
       })
      })
      .catch(function(error) {});

  }


  assignedOrdersList(){

     const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/orders/', { param: payload })
      .then((response) => {
       console.log(response.data.data.unassigned_orders);
       this.setState({
        unAssignOrder: response.data.data.unassigned_orders,
        assignOrder: response.data.data.assigned_orders

       })
      })
      .catch(function(error) {});

  }

  AssignData(){
  this.setState({
    submitData: true
  })
  var arrayData = this.state.arr_data

    //var arrayData = this.state.arr_data

    var arr = [];

    for (var i = 0; i < arrayData.length; i++) {
      var obj = {};
      //arr.push(arrayData[i].id);

      obj['id'] = arrayData[i].id;
      obj['picked_icld_qty'] = arrayData[i].edit_qty_icld;
      obj['picked_loose_qty'] = arrayData[i].edit_qty_loose;
      
      obj['auditor'] = this.state.selectedAudit;
      obj['reason'] = arrayData[i].edit_reason;

      if(arrayData[i].edit_qty_crate == "" || arrayData[i].edit_qty_crate == undefined || arrayData[i].edit_qty_crate == null){
        obj['crate_id'] = "default"
      }else{
        obj['crate_id'] = arrayData[i].edit_qty_crate;
      }

      arr.push(obj);

    }
    

    const payload = {
      arr
  };

  addAnalytics('Loose & CLD Confirmation', 'Loose & CLD Confirm', payload);

API.post('/picking/manualTaskUpdate', { param: payload })
      .then((response) => {
        console.log(response.data);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
          success_message: response.data.message,
          //SuccessConfirmmodal: false
        });
        if(response.data[0].status == true){
          this.toggle2();
          this.setState({
            showFetchDispatchData: false,
            selectedGroup: ""

          })
        }else{
        this.Failedtoggle();
        }
        this.setState({
        SuccessConfirmmodal: false,
        showCreatedId: false,
        showSelectGroup: false,
        showNewGroup: false,
        assignLoader: false,
        assignDisabled: false,
        createDisabled: false,
        submitData: false
        })
        
        //this.fetchDispatch();
      })
      .catch(function(error) {});

  }
  UnAssignData(){
    const payload = {
      location: this.state.selectedLocation,
      type: "unassign",
      group_id: this.state.selectedGroup,
      order_id: unassign_arr
  };

API.post('/product/product_master/v1/group/unassign/', { param: payload })
      .then((response) => {
        alert(response.data.message);
        this.setState({
          variant1: response.data.data,
          loading_overlay: true,
        });
        
        this.fetchDispatch();
      })
      .catch(function(error) {});

  }

  checkedSingle(index, ischecked,orderid) {
    
    var arr=[];
    console.log(this.state.binData);
    this.setState({
      loading_overlay: true
    })
    let newData = this.state.arr_data;
    if (newData[index].isChecked === false) {
      newData[index].isChecked = true;
      //data_type = "assign";
      assign_arr.push(orderid);
      
    } else if (newData[index].isChecked === true) {
      newData[index].isChecked = false;
      //data_type = "unassign";
      unassign_arr.push(orderid);
      
    }

    console.log(newData);
    this.setState({
      tableRowsMap: this.assembleDispatchData(newData),
      //binData: newData,
      arr_data: newData
    });

    

    
  }

  toggleOK() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }
  toggle1() {
    this.setState((prevState) => ({ modal1: !prevState.modal1 }));
  }


  toggle2() {
    this.setState((prevState) => ({ modal2: !prevState.modal2 }));
  }

  toggle2OK() {
    window.location.href = "";
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }


  SuccessConfirmtoggle() {
    this.setState((prevState) => ({
      SuccessConfirmmodal: !prevState.SuccessConfirmmodal,
    }));
  }

  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41"+":8088";
    } else {
      url = window.location.hostname+port;
    }
    
    sessionStorage.setItem('PUstore_id', '')
    sessionStorage.setItem('PUpolaris_id', '')
    sessionStorage.setItem('PUstatus_type', '')
    sessionStorage.setItem('PUtask_type_value', '')
    sessionStorage.setItem('PUtask_id', '')

  /* sessionStorage.setItem('store_id', this.state.store_id)
    sessionStorage.setItem('polaris_id', this.state.polaris_id)
    sessionStorage.setItem('status_type', this.state.status_type)
    sessionStorage.setItem('task_type_value', this.state.task_type_value)
    sessionStorage.setItem('task_id', this.state.task_id)
*/

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
        store_id: sessionStorage.getItem('store_id') == "null" ? "" : sessionStorage.getItem('store_id') ,
        polaris_id: sessionStorage.getItem('polaris_id') == "null" ? "" : sessionStorage.getItem('polaris_id') ,
        task_id: sessionStorage.getItem('task_id') == "null" ? "" : sessionStorage.getItem('task_id') ,
        status_type: sessionStorage.getItem('status_type') == "null" || sessionStorage.getItem('status_type') == "" ? "1" : sessionStorage.getItem('status_type') ,
        task_type_value: sessionStorage.getItem('task_type_value') == "null" ? "" : sessionStorage.getItem('task_type_value')

      },
      () => {
        
        this.getPicksheetId();
        this.getReason();
        this.getAudit();
        
      }
    );
  }

  

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

 

   getStationList() {
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/sku/dropdown/', { param: payload })
      .then((response) => {

       console.log(response);
        this.setState({ stationType: response.data.data });
      })

      .then(async () => {
        
      });

   
  }

  getStoreList() {
    
      const payload = {
        location: this.state.selectedLocation,

  };

API.post('/product/product_master/v1/orderno/dropdown/', { param: payload })

      .then((response) => response.data)

      .then((data) => {
       console.log("BILL",data);
        this.setState({ store: data.data });
      })

      .then(async () => {
        
      });
  }

  getReason() {
    
    const payload = {
      location: this.state.selectedLocation,
      "screen_type": "cld_loose_confirm"
  };

API.post('/product/product_master/v1/reason/dropdown/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
     console.log('REASON',data);
      this.setState({ reasonData: data.data });
    })

    .then(async () => {
      
    });
}

getAudit() {
    
    const payload = {
      location: this.state.selectedLocation,
  };

API.post('/product/product_master/v1/auditor/dropdown/', { param: payload })

    .then((response) => response.data)

    .then((data) => {
     console.log("AUDIT",data);
      this.setState({ auditData: data.data });
    })

    .then(async () => {
      
    });
}

getPicksheetId() {
    
    const payload = {
      location: this.state.selectedLocation,
          //picksheetType: 2,
  };

API.post('/picking/fetchManualList', { param: payload })
      .then((response) => {
        console.log("response",response)
        this.setState({
          schemas: response.data,
        });
      })
      .catch(function(error) {});
}


  OpenAssign(data) {
    this.setState({
      taskid: data
    })
    this.SuccessConfirmtoggle();
    
  }

  handleChangeStation = (e) => {
      this.setState({
        selectedStation: e.target.value,
      });
  };


  handleChange = (e) => {
    this.setState({
      selectedPicksheet: e.target.value,
    });
  };

  changeSubGroup = (e) => {
    this.setState({
      selectedSubGroup: e.target.value,
    });
  };

  changeReason(evt,index){
    const {arr_data} = this.state;
    console.log("arr_data",arr_data);
    var reason = evt.target.value
    arr_data[index]['edit_reason'] = reason
    arr_data[index]['ischeckdata'] = "false"


    /*var arrayData = arr_data.filter(
      (item) => item.ischeckdata == "true"
    );*/

     var arrayData = arr_data.filter(
      (item) => (item.ischeckdata == "true")
    );

   

    if(arrayData.length > 0 || this.state.selectedAudit == "" || this.state.selectedAudit == "undefined" || this.state.selectedAudit == "null"){
       this.setState({
          isDisableConfirm: true,
         
        })

    }else{
      this.setState({
          isDisableConfirm: false,
         
        })
    }

    //console.log(reviewData);
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });
  };

  changeAudit = (evt,index) => {
     const {arr_data} = this.state;
    console.log(arr_data);
    var arrayData = arr_data.filter(
      (item) => (item.ischeckdata == "true")
    );

    
    this.setState({
      selectedAudit: evt.target.value
    })
   
    if(arrayData.length > 0){
       this.setState({
          isDisableConfirm: true,
         
        })

    }else{
      this.setState({
          isDisableConfirm: false,
         
        })
    }

    /* const {arr_data} = this.state;
    var auditor = evt.target.value
    arr_data[index]['edit_auditor'] = auditor

  
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });*/
  };

  changePackedQty = (evt,index, id, order_qty) => {
    console.log(evt.target.value);
    const {arr_data} = this.state;
    const value = evt.target.value.replace(/\D/g, "");
    
        var packed_qty = value

    var objIndex = arr_data.findIndex((obj => obj.id == id));
    arr_data[index]['edit_qty_icld'] = packed_qty
    //arr_data[index]['total_dispatch_qty'] = packed_qty
    if(evt.target.value == "" || evt.target.value == undefined || evt.target.value == null){
      arr_data[index]['ischeckdata'] = "false";
      arr_data[index]['dataChecked'] = false
    }else{
      arr_data[index]['ischeckdata'] = "true"
      arr_data[index]['dataChecked'] = true
    }

    if(packed_qty > order_qty ){
         arr_data[objIndex]['pickedcld'] = true
        
      }else{
        arr_data[objIndex]['pickedcld'] = false

      }

    console.log(arr_data);
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });
    
  };

  changeCrateQty = (evt, index) => {
    const {arr_data} = this.state;
    var crate_qty = evt.target.value
    
    arr_data[index]['edit_qty_crate'] = crate_qty
    //arr_data[index]['total_dispatch_qty'] = packed_qty
    if(evt.target.value == "" || evt.target.value == undefined || evt.target.value == null){
      arr_data[index]['crate_check'] = false;
    }else{
      arr_data[index]['crate_check'] = true
    }

    var arrayData = arr_data.filter(
      (item) => (item.ischeckdata == "true")
    );

     if(arrayData.length > 0 || this.state.selectedAudit == "" || this.state.selectedAudit == "undefined" || this.state.selectedAudit == "null"){
       this.setState({
          isDisableConfirm: true,
         
        })

    }else{
      this.setState({
          isDisableConfirm: false,
         
        })
    }

    console.log(arr_data);
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });    
  }



  changePackedQtyLoose = (evt,index, icld_qty, id, order_qty) => {
    console.log(evt.target.value);
    const {arr_data} = this.state;
    const value = evt.target.value.replace(/\D/g, "");
    
        var packed_qty = value

     var objIndex = arr_data.findIndex((obj => obj.id == id));
    arr_data[index]['edit_qty_loose'] = packed_qty
    //arr_data[index]['total_dispatch_qty'] = packed_qty
    if(evt.target.value == "" || evt.target.value == undefined || evt.target.value == null || packed_qty <= icld_qty){
      arr_data[index]['ischeckdata'] = "false";
      arr_data[index]['dataChecked'] = false
    }else{
      arr_data[index]['ischeckdata'] = "true"
      arr_data[index]['dataChecked'] = true
    }

     if(packed_qty > order_qty ){
         arr_data[objIndex]['pickedloose'] = true
        
      }else{
        arr_data[objIndex]['pickedloose'] = false

      }


    console.log(arr_data);
    this.setState({
      arr_data: arr_data,
      tableRowsMap: this.assembleDispatchData(arr_data),
    });
    
  };
 

  handleChangeStation = (e) => {
      this.setState({
        selectedStation: e.target.value,
      });
  };



  assembleDispatchData = (dispatchData) => {
    console.log("dispatchData", dispatchData)
    let DispatchData = dispatchData.map((post, index) => {
      return {
        
        product__sku7_code: post.product__sku7_code,
        product_desc: post.product__lb_sku_product_name,
        mrp: post.product__mrp,
        to_picked_icld_qty: post.to_pick_icld_qty,
        picked_icld_qty: <span> <input style={{fontSize: 12, height: 31, width: 100}} type = "text"  className="form-control" value={post.edit_qty_icld} placeholder="Enter Picked icld Qty" onChange={(evt) => this.changePackedQty(evt,index,post.id, post.to_pick_icld_qty)}  /> <br/>{post.pickedcld == true && <span className={"err_qty_"+post.id} style={{fontSize: 11, color: 'red'}}>Qty Cannot be greater than To be picked cld</span>}</span>,

        to_picked_loose_qty: post.to_pick_loose_qty,
         
        
        picked_loose_qty: <span> <input style={{fontSize: 12, height: 31, width: 100}} type = "text"  className="form-control" value={post.edit_qty_loose} placeholder="Enter Picked loose Qty" onChange={(evt) => this.changePackedQtyLoose(evt,index,post.edit_qty_icld, post.id, post.to_pick_loose_qty)}  /><br/>{post.pickedloose == true && <span className={"err_qty_"+post.id} style={{fontSize: 11, color: 'red'}}>Qty Cannot be greater than To be picked loose</span>}</span>, 
        crate_id: <input style={{fontSize: 12, height: 31, width: 100}} value={post.edit_qty_crate} type = "text"  className="form-control" placeholder="Enter Crate" onChange={(evt) => this.changeCrateQty(evt,index)}  />,
            
        
        
        edit_reason: <span> <select
                    className="form-control"
                    value={post.edit_reason}
                    style={{ fontSize: 13,  width: 100 }}
                    onChange={(evt) => this.changeReason(evt,index)}
                  >
                    <option value="">Select Reason</option>
                    {
                      this.state.reasonData.length > 0 &&
                      this.state.reasonData.map((reasonData) => {
                        return (
                          <option value={reasonData.id}> {reasonData.name}</option>
                        );
                      })}
                  </select> <br/> {post.ischeckdata == "true" && <span style={{fontSize: 12, color: 'red'}}> Please Select Reason</span>}</span>, 
       
        /*action: <a style={{color: '#70bbfd'}}  onClick={(e) => this.AssignData(post.id, post.edit_qty, post.edit_auditor, post.edit_reason)} > Save </a>,  */

      };
    });

    this.setState({
      loading_overlay: false,
      loading: false,
    });

    return DispatchData;
  };


  SearchData(){
    console.log("ARR",this.state.arr_data)
    this.setState({
    loading_overlay: true
    })
    var newArrData = [];
     newArrData = this.state.arr_data.filter(
      (item) => item.party_code == this.state.selectedOutlet || item.distributor_code == this.state.selectedDistributor || item.delivery_center == this.state.selectedLocation || item.outlet_order_no == this.state.selectedOrder
    );
       
    console.log("filterData", newArrData);

    this.setState({
    arr_data: newArrData,
    tableRowsMap: this.assembleDispatchData(newArrData),
    })
  }

  changePage(value){
    console.log(value); 
  }


  downloadError = () => {
    //this.setState({loading:true})
    const payload = {
      location: this.state.selectedLocation,
      group_id: this.state.selectedGroup,
      station_type: this.state.selectedStation
  };

API.post('/product/product_master/v1/task/fetch/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          //showFetchDispatchData: true,
          loading: false
        });

        window.location.href= data.data[0]
      })
      .catch(function (error) {});
  };


  
  checkAll() {
    if (this.state.isChecked === false) {
      this.setState({
        isChecked: true,
        showSelectedBin: true,
      });

      //let newData = this.state.arr_data

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: true,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: false,
      });*/
    } else if (this.state.isChecked === true) {
      this.setState({
        isChecked: false,
        showSelectedBin: false,
      });

      let newData = this.state.arr_data.map((item) => ({
        ...item,
        isChecked: false,
      }));

      this.setState({
        tableRowsMap: this.assembleDispatchData(newData),
        arr_data: newData,
        //SelectedBins: newBinData,
      });

      /*console.log(this.state.binData);
      this.setState({
        isdisableAssignBtn: true,
      });*/
    }
  }
  
   fetchDispatch = (order_no) => {
    var arr_data = [];
    var total_val = 0;
    var total_qty = 0;
    this.setState({
      //loading_overlay: true,
      loading: true,
    });

    var batch = localStorage.getItem('batch_id');

    const payload = {
      location: this.state.selectedLocation,
      ptl_id: this.state.selectedPicksheet,
      sku: this.state.selectedStation,
  };
   addAnalytics('Loose & CLD Confirmation', 'Losse & Cld Confirmation Filter', payload);

API.post('/picking/fetchManualTasks', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log("DataVal", data);
        this.setState({
          showFetchDispatchData: true,
          loading: false
        });

        if (data.length == 0) {
          this.toggle();
// alert(data.message)
          this.setState({
            dispatch_status: true,
            showFetchDispatchData: false,
            loading_overlay: false,
            loading: false,
            
          });
          return false;
        }

        

        let DataValue = data.map((item) => ({
          ...item,
          edit_reason: "",
          edit_auditor: "",
          edit_qty_icld: item.picked_icld_qty,
          edit_qty_loose: item.picked_loose_qty,
          edit_qty_crate: "",
          isChecked: false,
          dataChecked: false,
          crate_check: false,
          ischeckdata: "",
          pickedcld: false,
          pickedloose: false
        }));

        console.log('DataValue', DataValue);


        this.setState({
          
          arr_data: DataValue,
          tableRowsMap: this.assembleDispatchData(DataValue),
          showFetchDispatchData: true,
          dispatch_status: false,
        });
      })
      .catch(function(error) {});
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal, modal1, modal2 } = this.state;
    const { SuccessConfirmmodal, Failedmodal } = this.state;

    const dispatchData = {
      columns: [
        

        {
          label: "Product",

          field: "product__sku7_code",
          width: 100,
        },

        {
          label: "Product Desc",

          field: "product_desc",
          width: 160,
        },


        {
          label: "MRP",

          field: "mrp",
          width: 60,
        },

        {
          label: "To be picked CLD",

          field: "to_picked_icld_qty",
          width: 150,
        },
         {
          label: "Picked CLD qty",

          field: "picked_icld_qty",
          width: 130,
        },
        {
          label: "To be Picked loose",

          field: "to_picked_loose_qty",
          width: 150,
        },
        
         
        {
          label: "Picked loose qty",

          field: "picked_loose_qty",
          width: 135,
        },

        {
          label: "Crate Id",

          field: "crate_id",
          width: 110,
        },
        
        {
          label: "Select Reason",

          field: "edit_reason",
          width: 130,
        }
        
       
      ],

      rows: this.state.tableRowsMap,
    };

    return (
      <Col xl={12}>
        
        {this.state.loading_overlay && (
          <LoadingOverlay active={true} spinner text="wertyui" />
        )}
        <Card>
          <CardBody style={{ paddingTop: 10, height: 56, paddingBottom: 0 }}>
           

            <form className="form form--inline" onSubmit={handleSubmit}>
              

               <div
                className="form__form-group col-xl-3"
                style={{marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  
                >
                  <select
                    className="form-control grn_line_no"
                    style={{ fontSize: 13 }}
                    value={this.state.value}
                    onChange={this.handleChange}
                  >
                    <option value="0" dis>
                      Select Picksheet No.
                    </option>
                    {this.state.schemas &&
                      this.state.schemas.length > 0 &&
                      this.state.schemas.map((schema) => {
                        return (
                          <option value={schema}>
                            {" "}
                            {schema}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div
                className="form__form-group col-xl-2"
                style={{ display: "inline-flex", marginBottom: "0px" }}
              >
                <div
                  className="form__form-group-field"
                  style={{ display: "contents" }}
                >
                  <input style={{fontSize: 12, borderColor: '#ced4da'}} type = "text"  className="form-control" placeholder="Enter SKU" onChange={this.handleChangeStation} />
                </div>
              </div>

              

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={() => this.fetchDispatch()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Search
                  </Button>
                </ButtonToolbar>
              </div>
             
            </form>
          </CardBody>

          {this.state.showFetchDispatchData && (
            <CardBody style={{ marginTop: 2, paddingTop: 0, paddingBottom: 0 }}>
              
             <div
                className="dispatchData stock_check_data style_table"
                style={{ marginTop: -27 }}
              >

               
               <select
                    className="form-control"
                    value={this.state.store_id}
                    onChange={this.changeAudit}
                    style={{marginBottom: 0, marginTop:34, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontSize: 13, width: 200, float: 'left', marginRight: 6}}
                  >
                    <option value="">Select Auditor</option>
                    {
                      this.state.auditData.length > 0 &&
                      this.state.auditData.map((auditData) => {
                        return (
                          <option value={auditData}> {auditData}</option>
                        );
                      })}
                  </select>

                  <Button disabled={this.state.isDisableConfirm} style={{marginBottom: 0, marginTop:34, paddingTop: 5, paddingBottom:5, paddingLeft: 26, paddingRight: 26 , fontWeight: 'bold'}} variant="warning" onClick={(e) => this.SuccessConfirmtoggle()}>Confirm</Button>
                <div style={{width: '100%', float: 'left', marginTop: 20}}>
                <MDBDataTable
                  scrollX
                  scrollY
                  maxHeight="390px"
                  displayEntries={false}
                  paging= {false}
                  searching={false}
                  onPageChange={(value) => this.changePage(value)}
                  sorting={false}
                  sortable={false}
                  striped
                  bordered
                  data={dispatchData}
                />
                </div>
              </div>        
            </CardBody>
          )}
        </Card>

        <Modal backdrop="static" isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-down modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>No Records Available </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggleOK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
        <Modal backdrop="static" isOpen={modal2} toggle={this.toggle2}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle2}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" ,margin:4}}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.toggle2OK}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

          <Modal backdrop="static" isOpen={Failedmodal} toggle={this.Failedtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>   

        <Modal backdrop="static" isOpen={SuccessConfirmmodal} toggle={this.SuccessConfirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.SuccessConfirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
           <h4>Please Check Picked Quantity and Press Ok Button for further process </h4>
            
           
            
           
            
          </div>
          <ButtonToolbar className="modal__footer">
            <button
                  style={{ marginRight: 8 }}
                  className="modal_cancel"
                  onClick={this.SuccessConfirmtoggle}
                >
                  Cancel
                </button>

            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.AssignData}
            >
              {this.state.submitData && (
                <i
                  className="fa fa-refresh fa-spin"
                  style={{ marginRight: "5px" }}
                />
              )}
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>  
      </Col>
    );
  }
}



export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
